module.exports = __webpack_public_path__ + "static/connect_03-6b2212b9c265404fc16d812c53b1bfaa.png";